import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractDataProvider } from '@epicuro-next/data-providers/base-data-provider';
import { filter, map, Observable } from 'rxjs';

import { HttpProviderService } from './http-provider.service';

@Injectable()
export class HttpBodyProviderService implements AbstractDataProvider {
  constructor(private readonly httpProviderService: HttpProviderService) {}

  public read<T>(fetchStringOrUrl: string): Observable<T> {
    return this.httpProviderService
      .read<HttpResponse<unknown>>(fetchStringOrUrl)
      .pipe(
        filter((data) => !!data && !!data.body),
        map((data) => {
          return data.body;
        }),
      ) as Observable<T>;
  }

  public write(): void {
    // Satisfying the contract
  }
}
